import {css, Stack, styled} from '@mui/material';
import {StyledContainerType} from './types';

const StyledContainer = styled(Stack)<StyledContainerType>`
	padding: 32px;
	padding-top: 24px;
	gap: 24px;
	height: 100%;

	${({isMobile}) =>
		isMobile
			? css`
					padding: 16px;
					padding-bottom: 72px;
				`
			: null}
`;

export {StyledContainer};
